import React from 'react';
import { Card, Elevation } from "@blueprintjs/core";

const ELEVATIONS = {
    0: Elevation.ZERO,
    1: Elevation.ONE,
    2: Elevation.TWO,
    3: Elevation.THREE,
    4: Elevation.FOUR
}

const CustomCard = ({ children, elevation, ...props }) => {
    let elevate = ELEVATIONS[elevation];
    
    return (
        <Card elevation={elevate} {...props}>
            {children}
        </Card>
    );
};

export default CustomCard;